import Icon from 'components/priority/Icon/Icon'
import { Tooltip } from '@/components/global/Tooltip/Tooltip'

export const ToolbarIcon = ({
  icon,
  tooltip,
  'data-testid': testId,
  ...props
}) => (
  <Tooltip text={tooltip} offsetY={16} clickable {...props}>
    <div data-testid={testId}>
      <Icon icon={icon} fill="lockedWhite" margin="0 12px" />
    </div>
  </Tooltip>
)

export default ToolbarIcon
